import axios from "axios";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { DASHBOARD_ROUTE } from "../../../../routes";
import authServices from "../../../../services/authServices";
import dataProvider from "../../../../services/dataProvider";
import DataTable from "../../common/data-table/data-table";
import { ADD_MEMBERS_ROUTE, EDIT_MEMBERS_ROUTE, MEMBER_PROFILE_ROUTE } from "../../dashboard-routes";

import { ReactComponent as ExpiredIcon } from "../../../../assets/icons/expired.svg";
import { ReactComponent as ActiveIcon } from "../../../../assets/icons/verified.svg";
import qs from "qs";

const MemberOverview = ({ history }) => {
    const [searchText, setSearchText] = useState("");
    const [tableData, setTableData] = useState([]);
    const [fetchComplete, setFetchComplete] = useState(false);
    // const [licenseIds, setLicenseIds] = useState([]);
    const [errorMsg, setErrorMsg] = useState("");
    const [isCheckingHealth, setIsCheckingHealth] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);

    function editProfile(id) {
        history.push({
            pathname: DASHBOARD_ROUTE + EDIT_MEMBERS_ROUTE,
            state: {
                member_id: id,
            },
        });
    }

    function deleteProfile(id) {
        //console.log("DELETE PROFILE", id);
    }

    async function healthCheck() {
        let selectedLicenseIds = selectedRows.map(row => row.id) ;
        setErrorMsg("");
        setIsCheckingHealth(true);
        let [nswToken, error] = await authServices.getNSWAccessToken();

        if (error) {
            console.error(error);
            setErrorMsg(error);
            return;
        }

        // const lid = ["T2JeXnhjUUWYDaVgrTg8VohrRpF2","vQ6JT8WnITdp23GUCHoYazTROw62"] ;
        // console.log(JSON.stringify(licenseIds));
        var data = qs.stringify({
            memberIds: JSON.stringify(selectedLicenseIds),
            nswAccessToken: nswToken,
        });

        // console.log("data", qs.parse(data));

        var config = {
            method: "post",
            url: dataProvider.baseUrl + "nswapi-healthCheck",
            headers: {
                token: authServices.getToken(),
                orgid: authServices.getOrgId(),
                "Content-Type": "application/x-www-form-urlencoded",
            },
            data: data,
        };

        axios(config)
            .then(function (response) {
                setIsCheckingHealth(false);
                if(response.data.status === "success") {
                    // todo remove timeout if we change the page
                    setTimeout(()=>{
                        location.reload();
                    },2000)
                }
            })
            .catch(function (error) {
                console.error(error);
                setErrorMsg(error.message);
                setIsCheckingHealth(false);
            });
    }

    function formatTableData(response) {
        // setLicenseIds(() => []);
        return response.data.message.map((msg) => {
            let expiryTimeInMs = new Date(msg.data.expiry).getTime();
            let todayTimeInMS = new Date().getTime();

            let status ;
            status = expiryTimeInMs > todayTimeInMS;

            if(msg.data?.healthCheckData) {
                status = (msg.data.healthCheckData.status === "Current" ? true : false) ;
                // console.log(msg.data.licenseNumber,msg.data.healthCheckData.status);
            }


            msg.data.licenseStatus = status ? "Active" : "Inactive" ;
            // setLicenseIds((ids) => [...ids, msg.id]);
            return {
                fullName: (
                    <Link
                        to={{
                            pathname: DASHBOARD_ROUTE + MEMBER_PROFILE_ROUTE,
                            state: {
                                memberData: {...msg},
                            },
                        }}
                    >
                        {msg.data.fullName}
                    </Link>
                ),
                fullNameText: msg.data.fullName,
                role: msg.data.role,
                licenseNumber: msg.data.licenseNumber,
                id: msg.id,
                actions: (
                    <div className="d-flex align-items-center">
                        <div className="d-flex align-items-center justify-content-center">
                            {status ? (
                                <div className="d-flex align-items-center" style={{ width: "6rem" }}>
                                    <ActiveIcon height="32" />
                                    <div className="text-primary mx-2">Active</div>
                                </div>
                            ) : (
                                <div className="d-flex align-items-center" style={{ width: "6rem" }}>
                                    <ExpiredIcon height="32" />
                                    <div className="text-danger mx-2">Inactive</div>
                                </div>
                            )}
                        </div>
                        <button
                            onClick={() => editProfile(msg.id)}
                            className="btn text-primary m-1 text-nowrap no-border border-start border-2"
                        >
                            Edit Profile
                        </button>
                        <button
                            onClick={() => deleteProfile(msg.id)}
                            className="btn text-primary m-1 text-nowrap no-border border-start border-2"
                        >
                            Delete Profile
                        </button>
                    </div>
                ),
            };
        });
    }

    useEffect(() => {
        var config = {
            method: "get",
            url: dataProvider.baseUrl + "getAllMembers",
            headers: {
                token: authServices.getToken(),
                orgid: authServices.getOrgId(),
            },
        };

        axios(config)
            .then(function (response) {
                setFetchComplete(true);
                if (response.data.status === "success") {
                    let formatedTableData = formatTableData(response);
                    formatedTableData = formatedTableData.sort((a, b) => {
                        if (!a.fullNameText) return 0;
                        return a.fullNameText.toLowerCase() > b.fullNameText.toLowerCase()
                            ? 1
                            : b.fullNameText.toLowerCase() > a.fullNameText.toLowerCase()
                            ? -1
                            : 0;
                    })
                    setTableData(formatedTableData);
                } else {
                    console.error(response);
                }
            })
            .catch(function (error) {
                setFetchComplete(true);
                console.error(error);
            });
    }, []);

    let tableHeaders = [
        { name: "Name", key: "fullName" },
        { name: "Role", key: "role" },
        { name: "Regno or License", key: "licenseNumber" },
        { name: "Status", key: "actions" },
    ];

    return (
        <div id="members-overview">
            <div className="container-fluid p-0">
                <div className="d-flex align-items-center flex-row card p-4 no-radius  border-0 border-bottom">
                    <div className="m-0 h5">Members</div>
                    <div className="flex-fill"></div>
                </div>
            </div>

            {errorMsg && (
                <div className="container-fluid py-0 mt-3 px-3">
                    <div className="alert alert-danger m-0" role="alert">
                        {errorMsg}
                    </div>
                </div>
            )}

            {fetchComplete ? (
                <div className="container-fluid p-3">
                    <div className="card p-3">
                        <div className="d-block d-md-flex align-items-center">
                            <label htmlFor="searchtext" className="text-nowrap text-2 me-3">
                                Search for Members :
                            </label>
                            <div>
                                <input
                                    type="text"
                                    className="form-control mt-md-0 mt-2"
                                    placeholder="Search Name"
                                    onChange={(e) => setSearchText(e.target.value)}
                                />
                            </div>
                            <div className="flex-fill d-flex align-items-center"></div>

                            {isCheckingHealth ? (
                                <button
                                    className="btn btn-outline-primary text-nowrap ms-lg-3 mt-3 mt-md-0 d-inline-flex align-items-center"
                                    disabled={true}
                                >
                                    Checking ...
                                    <div className="spinner-border spinner-border-sm ms-3" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </button>
                            ) : (
                                <button
                                    onClick={healthCheck}
                                    className="btn btn-outline-primary text-nowrap ms-lg-3 mt-3 mt-md-0"
                                    disabled={selectedRows.length === 0}
                                >
                                    Health Check
                                </button>
                            )}

                            <Link to={DASHBOARD_ROUTE + ADD_MEMBERS_ROUTE}>
                                <button className="btn btn-primary text-light text-nowrap ms-3 mt-3 mt-md-0">
                                    Add New Member
                                </button>
                            </Link>
                        </div>
                    </div>
                    <div className="card p-3 mt-3">
                        <div style={{ overflowY: "auto" }}>
                            <DataTable
                                header={tableHeaders}
                                rawData={tableData}
                                search={searchText}
                                // sortBy="fullNameText"
                                selectable
                                setSelectedRows={setSelectedRows}
                                paginate
                            />
                        </div>
                    </div>
                </div>
            ) : (
                <div className="container-fluid p-3">
                    <div className="card p-3 py-5 align-items-center">
                        <div className="d-flex align-items-center">
                            <div className="me-3">Fetching Member Data</div>
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default MemberOverview;
